import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";

import { UitkSpacing } from "uitk-react-spacing";
import { UitkMessagingCard, UitkMessagingCardSection } from "uitk-react-messaging-cards";
import { UitkText } from "uitk-react-text";

/**
 * This is the card that's displayed when no packages are available after applying a filter
 */
const NoFilteredPackagesAvailableMessage = React.memo(() => {
  const { formatText } = useLocalization();

  return (
    <UitkSpacing margin={{ blockstart: "three" }}>
      <UitkMessagingCard>
        <UitkMessagingCardSection heading={formatText("maps.filter.error.filterError.header")}>
          <UitkText size={300}>{formatText("maps.filter.error.filterError.message")}</UitkText>
        </UitkMessagingCardSection>
      </UitkMessagingCard>
    </UitkSpacing>
  );
});

export default NoFilteredPackagesAvailableMessage;
